import React, {Component} from 'react'
import {Button, Icon, Popup} from 'semantic-ui-react'
import Dropzone from 'react-dropzone'
import $ from 'jquery'

// PI files attached to a VPO, uploaded the same way as SO order details files
class VpoPiFiles extends Component
{
  constructor(props)
  {
    super(props)
    this.state = {
      addingFile: false,
      uploadingFile: false
    }

    this.handleAcceptedFiles = this.handleAcceptedFiles.bind(this)
    this.removeFile = this.removeFile.bind(this)
    this.downloadFile = this.downloadFile.bind(this)
  }

  handleAcceptedFiles(acceptedFiles) {
    acceptedFiles.forEach((file) => {
      let filename = file.name

      if (filename.toLowerCase().indexOf('.pdf') == -1) {
        alert('Only allow PDF file types.')
        return
      }

      let formData = new FormData()
      formData.append("file", file, file.name)

      this.setState({uploadingFile: true})

      $.ajax({
        type: "POST",
        url: process.env.REACT_APP_API_URL + '/api/file-upload-worksheet',
        success: (data) => {
          if (data.success) {
            this.props.setPiFiles(this.props.piFiles.concat([data.worksheet_filename]))
            this.setState({addingFile: false})
          } else if (!!data.corrupt_file) {
            alert('The file "' + filename + '" is corrupt.')
          } else {
            alert('There was an error when trying to upload the file "' + filename + '"')
          }
          this.setState({uploadingFile: false})
        },
        error: () => {
          alert('There was an error when trying to upload the file.')
          this.setState({uploadingFile: false})
        },
        async: true,
        data: formData,
        cache: false,
        contentType: false,
        processData: false,
        timeout: 60000
      })
    })
  }

  removeFile(filename) {
    if (window.confirm('Are you sure you want to remove the PI?')) {
      this.props.setPiFiles(this.props.piFiles.filter((x) => x != filename))
    }
  }

  downloadFile(filename) {
    let foldername = filename.split('/')[0]
    window.location.href = process.env.REACT_APP_API_URL + '/api/download_vpo_pi/' + this.props.vpoId +'?file=' + foldername
  }

  render() {
    let {piFiles, savedPiFiles} = this.props
    let {addingFile, uploadingFile} = this.state

    return (
      <div>
        <ul style={{margin: '5px 0'}}>
          {piFiles.map((filename) => {
            let d = new Date(0)
            d.setUTCSeconds(filename.split('/')[0].substr(32))

            return (
              <li key={filename} style={{marginBottom: '5px'}}>
                {filename.split('/').slice(1).join('/')}

                {savedPiFiles.indexOf(filename) > -1 ?
                  <Popup content='Download PI' trigger={<Button onClick={this.downloadFile.bind(null, filename)} color='green' basic icon='download' style={{marginLeft: '10px', padding: '5px'}}/>} />
                : null}

                <Popup content='Remove PI' trigger={<Button onClick={this.removeFile.bind(null, filename)} color='red' basic icon='trash' style={{marginLeft: '10px', padding: '5px'}}/>} />

                &nbsp;&nbsp; <small style={{opacity: 0.5, whiteSpace: 'nowrap'}}>Uploaded: {d.toLocaleDateString()}</small>
              </li>
            )
          })}
        </ul>

        {
          addingFile || piFiles.length == 0
          ?
          <Dropzone onDrop={this.handleAcceptedFiles}>
            {({getRootProps, getInputProps}) => (
              <section>
                <div {...getRootProps()} id="my-dropzone">
                  <input {...getInputProps()} />
                  <p>{uploadingFile ? 'Uploading...' : "Drag 'n' drop PI PDFs here, or click to select files"}</p>
                </div>
              </section>
            )}
          </Dropzone>
          :
          <Popup content='Add PI' trigger={<Button onClick={() => this.setState({addingFile: true})} basic size="mini" style={{paddingRight: '8px'}}><Icon name="plus"/></Button>} />
        }
      </div>
    )
  }
}

export default VpoPiFiles
